module.exports = __webpack_public_path__ + "static/media/RWTH_Logo.633422a5.png";